import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";

import { AxiosResponse } from "axios";
import StaticTable, { DataStructure } from "@/components/StaticTable";

interface ApiTableProps<T> {
  getData: () => Promise<AxiosResponse<T[]>>;
  dataStructure: DataStructure<T>[];
  dataId: keyof T;
}

export function ApiTable<T>({
  dataStructure,
  getData,
  dataId,
}: ApiTableProps<T>) {
  const { enqueueSnackbar } = useSnackbar();

  const [data, setData] = useState<T[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = (await getData()) as unknown as T[];
      setData(response);
    } catch (err: any) {
      enqueueSnackbar(err.toString(), {
        variant: "error",
      });
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StaticTable
      data={data}
      dataStructure={dataStructure}
      identifyRow={(row: T) => row[dataId]}
      loading={loading}
    />
  );
}
